import {readGuidedSearchArticlesIndex} from 'src/shared/guidedSearch/actions/articlesIndex';
import {readGuidedSearchHistory} from 'src/shared/guidedSearch/actions/guidedSearchHistory';

export const loadGuidedSearch = ({loadArticlesIndex}) => dispatch => {
  dispatch(readGuidedSearchHistory());
  if (loadArticlesIndex) {
    dispatch(readGuidedSearchArticlesIndex());
  }
};
